/* eslint-disable camelcase */
// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Define a service using a base URL and expected endpoints
export const clientNFTsApi = createApi({
  reducerPath: 'clientNFTsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `https://woj-platform.herokuapp.com`,
    prepareHeaders: (headers, { getState }) => {
      const { verifyToken } = getState().auth;
      if (verifyToken) {
        headers.set('authorization', `Bearer ${verifyToken}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    //  *****Get NFTs Cards*****

    getNFTs: builder.query({
      query: ({ limit, cursor }) => ({
        url: '/web3/nfts',
        params: {
          limit,
          cursor,
        },
      }),
    }),

    // *****Level Modal*****

    getLevelUpPrice: builder.query({
      query: (level) => ({
        url: `/nft/level/${level}/price`,
      }),
    }),

    levelUp: builder.mutation({
      query: ({ token_address, token_id }) => ({
        url: '/transaction/level-up',
        method: 'POST',
        body: {
          token_address,
          token_id,
        },
      }),
    }),
    verifyLevelUp: builder.mutation({
      query: ({ tx_hash, data_hash }) => ({
        url: '/transaction/level-up/verify',
        method: 'POST',
        body: {
          tx_hash,
          data_hash,
        },
      }),
    }),

    //  *****Energy Modal*****

    getEnergyPrice: builder.query({
      query: () => ({
        url: `/nft/energy/price`,
      }),
    }),

    energyUp: builder.mutation({
      query: ({ token_address, token_id, percent }) => ({
        url: '/transaction/energy-up',
        method: 'POST',
        body: {
          token_address,
          token_id,
          percent,
        },
      }),
    }),
    verifyEnergyUp: builder.mutation({
      query: ({ tx_hash, data_hash }) => ({
        url: '/transaction/energy-up/verify',
        method: 'POST',
        body: {
          tx_hash,
          data_hash,
        },
      }),
    }),

    // *****Set Profile Mutation*****

    setProfile: builder.mutation({
      query: ({ token_address, token_hash, token_id, twitter }) => ({
        url: '/user/twitter-profile',
        method: 'POST',
        body: {
          token_address,
          token_hash,
          token_id,
          twitter,
        },
      }),
    }),

    // *****Remove Profile Mutation*****

    removeProfile: builder.mutation({
      query: ({ token_address, token_id }) => ({
        url: '/user/twitter-profile',
        method: 'DELETE',
        body: {
          token_address,
          token_id,
        },
      }),
    }),

    // *****Veify Profile Mutation*****

    verifyProfile: builder.mutation({
      query: ({ token_address, token_hash, token_id, twitter }) => ({
        url: '/user/verify-twitter-profile',
        method: 'POST',
        body: {
          token_address,
          token_hash,
          token_id,
          twitter,
        },
      }),
    }),
    addGroup: builder.mutation({
      query: ({ parent_token_address, parent_token_id, subsets }) => ({
        url: '/nft/add-group',
        method: 'POST',
        body: {
          parent_token_address,
          parent_token_id,
          subsets,
        },
      }),
    }),

    // *****Get Invite Codes*****

    getInviteCodes: builder.query({
      query: () => ({
        url: '/user/invite-codes',
        method: 'GET',
      }),
    }),

    // *****Activation Code*****

    activate: builder.mutation({
      query: ({ code }) => ({
        url: '/user/activate',
        method: 'POST',
        body: {
          code,
        },
      }),
    }),
    // *****Deleting From Groups *****

    deleteFromGroups: builder.mutation({
      query: ({ token_address, token_id }) => ({
        url: '/nft/group',
        method: 'DELETE',
        body: {
          token_address,
          token_id,
        },
      }),
    }),

    //  ***** All energies up transaction *****

    getAllEnergyUpinquiry: builder.query({
      query: () => ({
        url: '/transaction/energy-up/all/inquiry',
      }),
    }),
    //  ***** All energies up transaction *****

    allEnergyUpTransaction: builder.mutation({
      query: () => ({
        url: '/transaction/energy-up/all',
        method: 'POST',
      }),
    }),
    //  ***** Verify all energies up transaction *****

    verifyAllEnergyUpTransaction: builder.mutation({
      query: ({ tx_hash, data_hash }) => ({
        url: '/transaction/energy-up/all/verify',
        method: 'POST',
        body: { tx_hash, data_hash },
      }),
    }),
    //  ***** Activations Blobs Dialog Permission *****

    getPermissionResult: builder.query({
      query: () => ({
        url: '/user/permission/special-reward',
      }),
    }),

    //  ***** Activate *****

    activateSpecialReward: builder.mutation({
      query: ({ codes }) => ({
        url: '/user/activate-special-reward',
        method: 'POST',
        body: { codes },
      }),
    }),

    //  ***** Activations Blobs *****

    getBlobs: builder.query({
      query: () => ({
        url: '/user/blob',
      }),
    }),

    //  ***** virtual invite codes *****

    getVirtualInviteCodes: builder.query({
      query: () => ({
        url: '/user/invite-codes/virtual',
      }),
    }),

    //  ***** Generate Code *****

    generateCode: builder.mutation({
      query: ({ child_id }) => ({
        url: '/user/generate-code',
        method: 'POST',
        body: { child_id },
      }),
    }),
  }),
});

export const {
  useGetNFTsQuery,
  useRemoveProfileMutation,
  useSetProfileMutation,
  useVerifyProfileMutation,
  useGetLevelUpPriceQuery,
  useGetEnergyPriceQuery,
  useLevelUpMutation,
  useEnergyUpMutation,
  useVerifyEnergyUpMutation,
  useVerifyLevelUpMutation,
  useAddGroupMutation,
  useActivateMutation,
  useGetInviteCodesQuery,
  useDeleteFromGroupsMutation,
  useAllEnergyUpTransactionMutation,
  useVerifyAllEnergyUpTransactionMutation,
  useGetAllEnergyUpinquiryQuery,
  useGetBlobsQuery,
  useGetPermissionResultQuery,
  useActivateSpecialRewardMutation,
  useGenerateCodeMutation,
  useGetVirtualInviteCodesQuery,
} = clientNFTsApi;
